import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { CONSTANTS } from '../../Constants/Constants';
import { Preferences, SetUserPreferencesRequest } from '../../models/dtos';
import { Estimate } from '../../models/common/RecentAndFavEstimate';
import { CommonDataService } from '../common-data.service';
import { UserProfileService } from '../common/user-profile.service';
import { PreferenceApiService } from '../api/preference.service';

@Injectable({ providedIn: 'root' })
export class PreferencesService {

  constructor(
    private readonly commonDataService: CommonDataService,
    private readonly userProfileService: UserProfileService,
    private readonly preferenceApiService: PreferenceApiService
  ) {}

  saveUserPreferenceData(preferencesObject: Preferences): void {
    const requestBodyRPN: SetUserPreferencesRequest = {
      userId: this.userProfileService.userInfo?.gid ?? '',
      preferences: preferencesObject,
      firePreferences: null,
      esPreferences: null,
      proposalPreferences: null,
      collaboratorPreferences: null,
      costReviewerPreferences: null,
      taxDetailsPreferences: null,
      resetPreferencesToDefault: false
    };
    this.preferenceApiService.setPreference(requestBodyRPN).pipe(take(CONSTANTS.ONE)).subscribe();
  }

  savePreferences(preferenceData: Preferences, favoriteEstimates: Estimate[], recentEstimates: Estimate[]): void {
    const updatedPreferences: Preferences = { ...preferenceData };
    updatedPreferences.favoriteEstimate = JSON.stringify(favoriteEstimates);
    updatedPreferences.recentFilesList = JSON.stringify(recentEstimates);
    this.saveUserPreferenceData(updatedPreferences);
    const localData = this.commonDataService.getPreferenceData();
    if (localData) {
      localData.preferences = updatedPreferences;
    }
  }

  addToRecentViewedEstimateList(estimateId: string, estimateName: string): void {
    const recentEstimate: Estimate = {
      id: estimateId,
      name: estimateName,
      date: new Date()
    };
    const preferenceData = this.commonDataService.getPreferenceData()?.preferences;
    if (preferenceData) {
      const favoriteEstimates: Estimate[] = preferenceData.favoriteEstimate ? JSON.parse(preferenceData.favoriteEstimate) as Estimate[] : [];
      const recentFilesList: Estimate[] = preferenceData.recentFilesList ? JSON.parse(preferenceData.recentFilesList) as Estimate[] : [];
      const filteredList = recentFilesList.filter(e => e.id !== estimateId);
      const updatedRecentFilesList = [recentEstimate, ...filteredList].slice(0, preferenceData.mostRecentlyOpenedEstimateListMaxItemCount || CONSTANTS.TWELVE);

      // fix for - Recently Opened Estimate Not Displayed in Recent List Until Page Refresh
      preferenceData.recentFilesList = JSON.stringify(updatedRecentFilesList);

      this.savePreferences(preferenceData, favoriteEstimates, updatedRecentFilesList);
    }
  }
}
